<div class="row h-100">
  <section class="col-md-4 super-compos-left-shadow overflow-hidden pe-3">
    <div class="mb-3 mt-2 position-relative">
      <i-title text="Profil" level="1"></i-title>
    </div>
    @for (box of boxes_params | sort: 'title' : 'ASC'; track box) {
      <div
        class="d-flex align-items-center mt-2 mb-2 pointer border rounded p-2 bg-light"
        [ngClass]="{ 'config-active': currentIDparams === box?.id }"
        (click)="box.click()">
        <i class="me-2" [ngClass]="box.icon"></i> {{ box.title }}
      </div>
    }
  </section>
  <section class="col-md-8">
    <router-outlet></router-outlet>
  </section>
</div>
